//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import CreateEditDataset from './components/createEditDataset.vue';
export default {
  components: { CreateEditDataset },
  data() {
    return {
      // 搜索表单
      searchForm: {
        name_fuzz: '',
      },
      payload: {
        limit: 10,
        offset: 0,
      },
      page: 1,
      pageSize: 10,
      total: 0,
      // 表格
      loading: false,
      list: [],
      // 弹窗
      visible: false,
      editData: {},
      openType: 'create',
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'aiAgentDatasets_agent_create',
        'aiAgentDatasets_agent_edit',
        'aiAgentDatasets_agent_delete',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }
      return jurisdictionObj;
    },
  },
  async created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      this.payload = {
        ...this.payload,
        limit: this.pageSize,
        offset: (this.page - 1) * this.pageSize,
      };
      try {
        const { datasets, total_count: total } = await this.$request({
          url: this.$api.listAgentDatasets,
          data: this.payload,
        });
        this.list = datasets;
        this.total = parseInt(total);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.list = [];
        this.loading = false;
      }
    },
    onAdd() {
      this.editData = {};
      this.openType = 'create';
      this.visible = true;
    },
    onEdit(row) {
      this.editData = row;
      this.openType = 'edit';
      this.visible = true;
    },
    onDetail(row) {
      this.$router.push({ name: `ai-dataset-documents`, query: { dataset_id: row.id } });
    },
    onRetrieval(row) {
      this.$router.push({ name: `ai-dataset-retrieval`, query: { dataset_id: row.id } });
    },
    async onDelete(row) {
      this.$confirm(`确定移除知识库[${row.name}]吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const data = {
          id: row.id,
        };
        console.log(data);
        await this.$request({
          url: this.$api.deleteAgentDataSet,
          data,
        });
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.getList();
      });
    },
    // 翻页器
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getList();
    },
    searchList() {
      this.page = 1;
      this.payload.name_fuzz = this.searchForm.name_fuzz || '';
      this.getList();
    },
    resetForm() {
      this.searchForm.name_fuzz = '';
      delete this.payload.name_fuzz;
      this.getList();
    },
  },
};
